import { render, staticRenderFns } from "./add-photo.vue?vue&type=template&id=294a2a4a&scoped=true&"
import script from "./add-photo.vue?vue&type=script&lang=js&"
export * from "./add-photo.vue?vue&type=script&lang=js&"
import style1 from "./add-photo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294a2a4a",
  null
  
)

export default component.exports